const PHONE_HREF = 'tel:+905362771709';
const WA_HREF = 'https://wa.me/905362771709';

export default function MobileCTA() {
  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 flex md:hidden">
      <a
        href={PHONE_HREF}
        className="flex-1 flex items-center justify-center gap-2 bg-[#111827] text-white text-xs font-bold tracking-widest uppercase py-4 cursor-pointer whitespace-nowrap"
      >
        <i className="ri-phone-line text-[#D4A853] text-base"></i>
        Hemen Ara
      </a>
      <a
        href={WA_HREF}
        target="_blank"
        rel="noopener noreferrer nofollow"
        className="flex-1 flex items-center justify-center gap-2 bg-[#D4A853] text-[#111827] text-xs font-bold tracking-widest uppercase py-4 cursor-pointer whitespace-nowrap"
      >
        <i className="ri-whatsapp-line text-base"></i>
        WhatsApp
      </a>
    </div>
  );
}
